export default __webpack_public_path__ + "static/media/complex_slide02.22025939.jpg";